import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { metaFor, ldJson, OG_ALT, OG_IMAGE } from "@/seo/meta";

const ensure = (selector, make) => document.head.querySelector(selector) || document.head.appendChild(make());

const setMeta = (key, value, attr = "name") => {
  const el = ensure(`meta[${attr}="${key}"]`, () => document.createElement("meta"));
  el.setAttribute(attr, key);
  el.setAttribute("content", value);
};

export const applyMeta = (m) => {
  document.title = m.title;
  setMeta("description", m.description);
  setMeta("robots", m.robots);
  setMeta("twitter:title", m.title);
  setMeta("twitter:description", m.description);
  setMeta("og:title", m.title, "property");
  setMeta("og:description", m.description, "property");
  setMeta("og:url", m.url, "property");
  setMeta("og:type", m.og || "website", "property");
  setMeta("og:image", m.image || OG_IMAGE, "property");
  setMeta("og:image:alt", m.imageAlt || OG_ALT, "property");
  setMeta("twitter:image", m.image || OG_IMAGE);
  setMeta("twitter:image:alt", m.imageAlt || OG_ALT);
  ensure('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" })).setAttribute("href", m.url);
  const ld = ensure("script#seo-ld", () => Object.assign(document.createElement("script"), { id: "seo-ld", type: "application/ld+json" }));
  ld.textContent = m.ld.length ? ldJson(m.ld) : "";
};

export const RouteMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => applyMeta(metaFor(pathname)), [pathname]);
  return null;
};
